/** 
* 自动生成文件，请勿修改 
* @name: 考核:考勤扣分规则管理
* @description: 考勤扣分规则管理(三期新增)
* @create: 2024/1/11 下午4:25:21
* @swagger: 2.0
* 合计:6条
*/ 
 
import APIObject from "../utils/APIObject.js" 
const attendanceRule = { 
	/** 1 summary:查询-分页	method:post */ 
	queryPage : new APIObject("/api/attendanceRule/queryPage.do"), 
	/** 2 summary:查询-不分页（全部）	method:post */ 
	queryAll : new APIObject("/api/attendanceRule/queryAll.do"), 
	/** 3 summary:删除-批量	method:post */ 
	batchDelete : new APIObject("/api/attendanceRule/batchDelete.do"), 
	/** 4 summary:新增/修改-单条	method:post */ 
	saveOrUpdate : new APIObject("/api/attendanceRule/saveOrUpdate.do"), 
	/** 5 summary:删除-单条	method:post */ 
	delete : new APIObject("/api/attendanceRule/delete.do"), 
	/** 6 summary:根据id查询	method:post */ 
	queryById : new APIObject("/api/attendanceRule/queryById.do"), 
};
export default attendanceRule;